<template>
  <div id="primarydiv">
    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

<div class="remote-app" v-if="found">
   <register id="register" v-if="task=='register'" @register_quit="register_quit"></register>
  <forgot id="forgot" v-if="task=='forgot'" @forgot_quit="forgot_quit"></forgot>
 <template v-if="task=='login'">
  <div style="width:100%;background-color: rgb(48, 48, 48);"> 
    <h2 class="ml-4" style="width:100%;background-color: rgb(48, 48, 48);">Login</h2>
    <hr>
  </div>


  <v-stepper v-model="steep" alt-labels :mobile="false" id="stepper" >
    <v-stepper-header>
      <v-stepper-step
        :complete="steep > 1"
        step="1"
      >
        Enter Email
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="steep > 2"
        step="2"
      >
        Enter Password
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
       Please Wait
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card>
<template>
  <v-form
  style="height: 60px;"
  dark
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
   color="grey lighten-2"
      class="mt-4 mb-4 pa-1"
      dark
      v-model="email"
      :rules="emailRules"
      label="Email"
      required
      outlined
    ></v-text-field>
  </v-form>
</template>
  </v-card>
    <v-row dense style="width:100%;">
 <v-col cols="12" sm="3" md="3">
      <v-btn
        class="mt-5 mr-1 ca-btn"
        color="primary"
        @click="checkemail"
        >
        Continue
      </v-btn>
</v-col>
 <v-col cols="12" sm="3" md="3">
    <v-btn
        class="mt-5 mr-1 ca-btn"
        color="primary"
        @click="show_forgot"
        >
        Forgot Password?
      </v-btn>
</v-col>
 <v-col cols="12" sm="3" md="3">
      <v-btn
        class="mt-5 ca-btn"
        color="primary"
        @click="show_register"
        >
        Register
      </v-btn>
</v-col>
<v-col cols="12" md="3" sm="3">
        <v-btn
        dark
        text
        class="mt-5 ca-btn white--text"
        color="black"
        @click="login_quit"
        >
        Cancel
      </v-btn>
</v-col>

</v-row>

      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card>
<template>
  <v-form
    style="height: 60px;"
    dark
    ref="form2"
    v-model="valid2"
    lazy-validation
  >
<!-- :append-icon="showeye ? 'mdi-eye-off' : 'mdi-eye'"  style="position: relative;top: -91px; left: 911px;" -->
      <v-text-field
        required
        color="grey lighten-2"
        class="mt-4 mb-4 pa-1"
        :append-icon="showeye ? `$eyeoff` : `$eye`" 
        @click:append="toggle_eye"
        :type="showeye ? 'text' : 'password'"
              v-model="password"
        label="Password"
        clearable
        outlined        
    ></v-text-field> 


  </v-form>
</template>
</v-card>

<v-row dense>
  <v-col cols="12" md="3" sm="3" >
            <v-btn class="ca-btn mt-3"
          color="primary"
          @click="check_password"
        >
          Continue
        </v-btn>
  </v-col>
 <v-col cols="12" md="3" sm="3" >
        <v-btn class="ca-btn mt-3" text @click="steep=1">
          Cancel
        </v-btn>
   </v-col>
   <v-col cols="12" md="6" sm="6" >
     <v-spacer></v-spacer>
   </v-col>
</v-row>



      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
        dark>
           <v-card-text dark>
      <h4>Please wait while you're log in is being processed.</h4>    
        </v-card-text>
      </v-card>

        <v-btn text  @click="steep = 1" class="ca-btn">
          Back
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
  </div>
    <div class="remote-app" v-if="!found">
    <h2>🌐 Unable to start network services for... </h2>
    <h3 class="ml-3">Domain Host- {{ allowedOrigin}}</h3>
  </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

.pointer{
  cursor: pointer;
}
#eyeoff,#eye{
  position: relative;
  top:-70px;
  left:100px;
  z-index:200;
}
.ca-btn{
  width:100%;
}
@media (min-width: 768px) {
  
.ca-btn{
  width: 170px;
  }
}


// .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
//    display: block !important;
// }

// @media only screen and (min-width: 768px) {

// .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
//     display: block !important;
// }
// }

// @media only screen and (min-width: 959.98px)
// {
// .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
//        display: block !important;
// }
// }



</style>

<script>
import { bus_common } from "../mixins/bus_common";
const forgot = () => import("./forgot.vue");
const register = () => import("./register.vue");
export default {
  name: "Home",
    mixins: [bus_common],
      components: {forgot, register  },
  data() {
    return {
            isWide: false,                  // true ⇢ viewport ≥ 768 px
      mql: null , 
      zIndex:500,
      task:"login", //overall what is displayed
      showeye:false,
      password:"",
      valid2:true,
      valid:true,
      email: '',
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    steep: 1,
    allowedOrigin:"",
    url:"",
    found:false,
    lst_domains:['https://devtrafficstats.renopd.com', 'https://newsroom.renopd.com/' ,'https://newsroom.renopd.com/#' ,'https://newsroom.renopd.com'],
    };
  },
computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
    overlay_prn: function () {
      return this.$store.state.overlay_prn_show;
    },
  },
  methods:{
    login_quit(){
      setTimeout(() => {
                window.parent.postMessage(
                { type: "Quit", payload: "quit" },   
                this.allowedOrigin      
                );
    }, 500);
    },
    show_register(){
      this.task="register"
    },
    register_quit(){
      this.task = "login";
    },
    forgot_quit(){
      this.task = "login";
    },
show_forgot(){
  this.task = "forgot";
},
toggle_eye(){
  this.showeye = !this.showeye;
},

check_password() {
       console.log("check_password");

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;
      formIn.password = this.password;

      formIn.apiname = "check_password";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);

          if (data.msg == "success") {
              self.steep = 3;
              setTimeout(() => 
              {
                window.parent.postMessage(
                { type: "Login", payload: self.email },   
                this.allowedOrigin      
                );
      this.password = "";
this.email = "";
this.steep = 1;
              }, 1000);


          }else{
           this.swall_it("Password Status", "Password not found. Use Forgot Password.", "warning", null, null);
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
checkemail() {
       console.log("checkmail");
if(    this.$refs.form.validate() == false){
        this.swall_it("Email Status", "Email format not correct.", "warning", null, null);
        return true;
}

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;

      formIn.apiname = "checkemail";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (data.msg == "found") {
                    self.steep = 2;
          }else{
           this.swall_it("Email Status", "Email not found. Please register.", "warning", null, null);
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
  },
  mounted() {
      console.log("mounted");
let self = this;
      setTimeout(() => {
         console.log("stepper_lables timeout");
           self._mql = window.matchMedia('(min-width: 748px)');

   // Set initial state
       self.isWide = this._mql.matches;
if (self.isWide ) {

        let stepper_lables = document.querySelectorAll(".v-stepper__label");
         stepper_lables.forEach(element => {
          element.style.setProperty('display', 'block', 'important');
          console.log("stepper_lables");
      });
}
      
      let eyes = document.getElementById("eyeoff");
      if (eyes != null) {
        eyes.style.position = "relative";
        eyes.style.left = "911px";
        eyes.style.top = "-91px";
        eyes = document.getElementById("eye");
        eyes.style.position = "relative";
        eyes.style.left = "911px";
        eyes.style.top = "-91px";
      }
     }, 500);

    // One-time “hello” message up to the parent
    //  this.allowedOrigin = this.$route.query.host;
    //  this.allowedOrigin = "https://" +  this.allowedOrigin;
      try {
          this.url = new URL(document.referrer || '');
      } catch (error) {
        this.url == ""
      }
  
     if(this.url == ""){
      this.allowedOrigin = "Unknown";
                this.swall_it("Error Starup", "Document.referrer failed.", "error", null, null);
      return true;
     }
     console.log("URL: " + this.url);
    const hostDomain = this.url.hostname;   // "example.com"  (may be "")
     this.allowedOrigin = 'https://' + this.url.hostname;

     this.lst_domains.forEach(dm => {
      if (dm == this.allowedOrigin || this.allowedOrigin.indexOf("localhost") > -1) {
      self.found = true;
        
      }
  
     });
     if (this.found) {
          setTimeout(() => {
          window.parent.postMessage(
      { type: "Hello", payload: "READY" },   // data
      this.allowedOrigin      // targetOrigin (always set!)
    );
    }, 1000);
     }


      
       this.show_loader(false);
  }
};
</script>